import e from "react";
import n from "classnames";
import { useTranslation as s } from "react-i18next";
import { UrlsAPI as m } from "../../../../../js/urls/index.js";
import p from "../../../../../common/resources/apple-wallet.svg.js";
import f from "../../../../../common/resources/google-wallet.svg.js";
import { isBrowser as r } from "../../../../utils.js";
import l from "./addToWallet.module.scss.js";
function T({
  force: a,
  url: o
}) {
  const { t: i } = s(), t = /iPhone|iPod|iPad/.test(
    r() ? navigator.platform : ""
  );
  if (!/(android)/i.test(
    r() ? navigator.userAgent : ""
  ) && !t && !a) return null;
  const d = m.replaceParameters(o, {
    wallet: t ? "apple" : "android"
  });
  return /* @__PURE__ */ e.createElement(
    "a",
    {
      "data-testid": "add-to-wallet",
      href: d,
      className: n({
        [l.wallet]: !0,
        [l.wallet__android]: !t,
        [l.wallet__apple]: t
      })
    },
    t && /* @__PURE__ */ e.createElement(p, null),
    !t && /* @__PURE__ */ e.createElement(f, null),
    i(t ? "addToWallet.apple" : "addToWallet.android")
  );
}
export {
  T as AddToWallet
};
//# sourceMappingURL=AddToWallet.js.map
